import { EAggregationAnalysisType } from '~/core/models'

export const AGGREGATION_ANALYSIS_MINIMUM_COMPANY_COUNT = 300
export const AGGREGATION_ANALYSIS_TOTAL_LIST_COUNT = 6

export const AGGREGATION_ANALYSIS_DEFAULT_SORT_BY = 'sector'
export const AGGREGATION_ANALYSIS_DEFAULT_SORT_ORDER: 'asc' | 'desc' = 'asc'

export const AGGREGATION_ANALYSIS_DEFAULT_TYPE: EAggregationAnalysisType = EAggregationAnalysisType.YEAR_ON_YEAR
